export const statusesOptions = [
  {
    value: undefined,
    label: 'All',
  },
  {
    value: 'ACTIVE',
    label: 'Current',
  },
  {
    // As "string-array" of statuses
    value: 'MANUAL_STOP_FUTURE,MANUAL_STOP_ALL,END_DATETIME_STOP,FREQUENCY_STOP,DELETE',
    label: 'Closed',
  },
];

export const frequencyOptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'with',
    label: 'With frequency',
  },
  {
    value: 'without',
    label: 'Without frequency',
  },
];

export const FORM_VIEW = 'form';
export const TASK_VIEW = 'task';

export const viewOptions = [
  {
    value: FORM_VIEW,
    label: 'Form view',
  },
  {
    value: TASK_VIEW,
    label: 'Task view',
  },
];

// Form view lists the initiations of a single form; task view lists the task initiations, each
// grouping the whole set of forms of a task. Only the two leading columns differ.
export const formTableColumns = [
  {
    key: 'name',
    label: 'Form name + attached text field',
  },
  {
    key: 'initiator',
    label: 'Form Initiator',
  },
  {
    key: 'initiationDate',
    label: 'Initiation date',
  },
  {
    key: 'nextInitiation',
    label: 'Next initiation',
  },
  {
    key: 'frequency',
    label: 'Frequency',
  },
  {
    key: 'actions',
    label: 'Actions',
  },
];

export const taskTableColumns = [
  {
    key: 'name',
    label: 'Task name',
  },
  {
    key: 'initiator',
    label: 'Task initiator',
  },
  ...formTableColumns.slice(2),
];

export const initialFiltersState = {
  // All: none selected
  submitterFacilities: [],
  initiators: [],
  // All
  status: statusesOptions[0],
  initiationDate: {
    start: null,
    end: null,
  },
  // All
  frequency: frequencyOptions[0],
  // Form view
  view: viewOptions[0],
};

// "Stop the initiation" of a task run. The single-form wording names the "Public" folder as well;
// the forms of a task are always assigned to their submitters, so they never sit in it.
export const taskStopFutureInitiationsLabel =
  'Stop all future scheduled task initiations, but allow users to finish current submissions from their “Forms assigned to me” and “Forms in progress” folders.';
export const taskRemoveCurrentInitiationsLabel =
  'Remove all current initiations from folders "Forms assigned to me", "Forms in Progress". Clicking this action means that this task initiation will not be available for submissions anymore. All future frequencies of this initiation will be stopped';
